/* JS AI Search part 6: search panel, rendering and event wiring. Loaded in order with the other js-ai-*.js files (see snippets/js-ai-search-boot.liquid).
   Overview and switches: see the header of js-ai-1-nlp.js. */
(function (root) {
  'use strict';
  var X = root.JSAIX = root.JSAIX || {};
  var cfg = root.JSAI;
  if (!X.ui) return;   // disabled or switched off (see part 5)
  var U = X.ui, copy = U.copy, state = U.state, h = U.h, money = U.money, priceLabel = U.priceLabel, imgUrl = U.imgUrl,
      productUrl = U.productUrl, searchUrl = U.searchUrl, loadEngine = U.loadEngine, verifyItems = U.verifyItems,
      verifyBundles = U.verifyBundles, aiAvailable = U.aiAvailable, interpret = U.interpret, logSearch = U.logSearch;
  var cleanText = X.cleanText, isConversational = X.isConversational, wantsSimilar = X.wantsSimilar, parseBudget = X.parseBudget, tokenize = X.tokenize;
  root.__JSAI_STARTED = true;
  // ---------------------------------------------------------------- panel
  function ensurePanel() {
    if (state.panel && document.body.contains(state.panel)) return state.panel;
    var p = h('div', { 'class': 'jsai-panel', role: 'region', 'aria-label': 'Search suggestions', 'aria-live': 'polite', hidden: '' });
    document.body.appendChild(p);
    state.panel = p;
    return p;
  }
  function placePanel() {
    var p = state.panel, input = state.input;
    if (!p || !input) return;
    var rect = input.getBoundingClientRect(), vw = document.documentElement.clientWidth;
    var width = Math.min(Math.max(rect.width, 340), vw - 16);
    var left = Math.max(8, Math.min(rect.left + window.pageXOffset, window.pageXOffset + vw - width - 8));
    p.style.top = Math.round(rect.bottom + window.pageYOffset + 4) + 'px';
    p.style.left = Math.round(left) + 'px';
    p.style.width = Math.round(width) + 'px';
  }
  function showPanel(content) {
    var p = ensurePanel();
    while (p.firstChild) p.removeChild(p.firstChild);
    content.forEach(function (c) { if (c) p.appendChild(c); });
    p.removeAttribute('hidden');
    placePanel();
  }
  function hidePanel() { state.seq++; if (state.panel) state.panel.setAttribute('hidden', ''); }

  function productRow(it, opts) {
    var single = it.variantCount === 1 && it.variants.length === 1 ? it.variants[0] : null;  // quick-add only for one-variant products
    var img = it.image ? h('img', { src: imgUrl(it.image, 120), alt: '', loading: 'lazy', width: '56', height: '56' }) : h('span', { 'class': 'jsai-noimg' });
    var link = h('a', { 'class': 'jsai-title', href: productUrl(it.handle), text: it.title });
    var meta = h('div', { 'class': 'jsai-meta' }, [
      h('span', { 'class': 'jsai-price', text: priceLabel(it) }),
      h('span', { 'class': 'jsai-stock', text: 'In stock' })
    ]);
    var action;
    if (single) {
      action = h('button', { type: 'button', 'class': 'jsai-btn', text: copy.add });
      action.addEventListener('click', function () { addToCart(single.id, action); });
    } else {
      action = h('a', { 'class': 'jsai-btn jsai-btn-alt', href: productUrl(it.handle), text: copy.options });
    }
    return h('li', { 'class': 'jsai-row' }, [
      h('a', { 'class': 'jsai-thumb', href: productUrl(it.handle), tabindex: '-1', 'aria-hidden': 'true' }, [img]),
      h('div', { 'class': 'jsai-info' }, [link, meta]), action
    ]);
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function () {
        btn.textContent = copy.added;
        btn.classList.add('jsai-done');
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          [].forEach.call(document.querySelectorAll('.tt-badge-cart, .cart-count, [data-cart-count]'), function (el) { el.textContent = cart.item_count; });
        }).catch(function () { /* count refreshes on next page load */ });
      })
      .catch(function () { btn.disabled = false; btn.textContent = copy.options; btn.onclick = function () { location.href = '/cart'; }; });
  }

  function section(title, listItems, note) {
    var kids = [h('div', { 'class': 'jsai-head', text: title }), h('ul', { 'class': 'jsai-list' }, listItems)];
    if (note) kids.push(note);
    return h('section', { 'class': 'jsai-section' }, kids);
  }

  function footer(q, extra) {
    return h('div', { 'class': 'jsai-foot' }, [
      extra ? h('p', { 'class': 'jsai-fine', text: extra }) : null,
      h('a', { 'class': 'jsai-all', href: searchUrl(q), text: copy.seeAll + ' →' }),
      h('p', { 'class': 'jsai-fine', text: copy.age })
    ]);
  }

  function render(q, reply, v, usedAi) {
    var nodes = [], kindHead = reply.kind === 'budget' ? copy.budgetHead : reply.budgetMax !== null ? copy.budgetHead : copy.matchHead;
    if (v.items && v.items.length) {
      var head = reply.query_similar ? copy.similarHead : kindHead;
      if (reply.budgetMax !== null) head += ' (' + (reply.budgetMin !== null ? money(reply.budgetMin) + '–' : 'up to ') + money(reply.budgetMax) + ')';
      nodes.push(section(head, v.items.map(function (it) { return productRow(it); })));
    }
    if (v.bundles && v.bundles.length) {
      var lis = [];
      v.bundles.forEach(function (b, i) {
        lis.push(h('li', { 'class': 'jsai-bundle' }, [
          h('div', { 'class': 'jsai-bundle-head', text: 'Option ' + (i + 1) + ' · ' + copy.total + ' ' + money(b.total) }),
          h('ul', { 'class': 'jsai-list' }, b.items.map(function (it) { return productRow(it); }))
        ]));
      });
      nodes.push(section(copy.bundleHead, lis));
    }
    if (v.alternatives && v.alternatives.length) {
      var soldNote = reply.soldOutTitles.length ? h('p', { 'class': 'jsai-fine', text: '“' + reply.soldOutTitles[0] + '” is ' + copy.sold + '.' }) : null;
      nodes.push(section(copy.altHead, v.alternatives.map(function (it) { return productRow(it); }), soldNote));
    }
    if (!nodes.length) {
      var chips = (state.engine ? state.engine.topTypes.slice(0, 6) : []).map(function (t) { return h('a', { 'class': 'jsai-chip', href: searchUrl(t), text: t }); });
      nodes.push(h('section', { 'class': 'jsai-section' }, [h('div', { 'class': 'jsai-head', text: copy.none }), h('div', { 'class': 'jsai-chips' }, chips)]));
    }
    var notes = [];
    if (usedAi) notes.push(copy.aiNote + '.');
    if (v.unverified) notes.push(copy.stale);
    nodes.push(footer(q, notes.join(' ')));
    showPanel(nodes);
  }

  function renderMedical(q) {
    showPanel([h('section', { 'class': 'jsai-section' }, [h('div', { 'class': 'jsai-head', text: 'We can’t give health advice' }),
      h('p', { 'class': 'jsai-fine', text: 'Try a product type, brand, size or price instead.' })]), footer(q)]);
  }

  // ---------------------------------------------------------------- orchestration
  /** Turn a request into an answer: rules engine, optional AI interpretation, optional live check.
      opts.limit = how many results to ask the engine for; opts.verify === false skips the live check
      (the results page checks live in batches as it shows them). */
  function resolve(q, opts) {
    opts = opts || {};
    var limit = opts.limit || 8;
    return loadEngine().then(function (engine) {
      var similar = wantsSimilar(q) && cfg.handle && !parseBudget(q).present && tokenize(q).filter(function (t) { return !engine.K.stop[t]; }).length <= 3;
      var reply = similar ? engine.similarTo(cfg.handle, limit) : engine.ask(q, limit);
      reply.query_similar = similar;
      if (reply.refusedMedical) return { medical: true, reply: reply };
      var needAi = reply.needsAi && !similar;
      var step = needAi ? aiAvailable().then(function (ok) { return ok ? interpret(q) : { ai: 'off' }; }) : Promise.resolve({ ai: 'none' });
      return step.then(function (res) {
        var aiState = res.ai || 'none';
        if (res.intent) {
          var r2 = engine.askIntent(res.intent, limit);
          if (r2.items.length || r2.bundles.length || r2.alternatives.length) reply = r2;
          else aiState = 'used';
        }
        var out = { reply: reply, aiState: aiState, usedAi: !!res.intent, engine: engine };
        if (opts.verify === false) return out;
        var budget = { min: reply.budgetMin, max: reply.budgetMax };
        return Promise.all([verifyItems(reply.items, budget, 5), verifyItems(reply.alternatives, { min: budget.min, max: budget.max }, 4), verifyBundles(reply.bundles, budget)]).then(function (all) {
          out.v = { items: all[0].items, alternatives: all[1].items, bundles: all[2].bundles, unverified: all[0].unverified || all[1].unverified || all[2].unverified };
          // everything we planned to show turned out to be sold out: offer alternatives, never the sold-out items
          reply.items = out.v.items; reply.alternatives = out.v.alternatives; reply.bundles = out.v.bundles;
          return out;
        });
      });
    });
  }

  function run(q, input) {
    var seq = ++state.seq;
    state.input = input; state.lastQuery = q;
    showPanel([h('div', { 'class': 'jsai-loading', text: copy.loading })]);
    resolve(q, { limit: 8 }).then(function (r) {
      if (seq !== state.seq) return;
      if (r.medical) { renderMedical(q); return; }
      render(q, r.reply, r.v, r.usedAi);
      setTimeout(function () { if (state.lastQuery === q) logSearch(q, r.reply, r.aiState, true); }, 900);
    }).catch(function () { hidePanel(); });   // any failure: step aside, the normal search still works
  }

  function isSearchInput(el) {
    if (!el || el.tagName !== 'INPUT' || el.name !== 'q') return false;
    var f = el.form;
    return !!f && /\/search\/?$/.test((f.getAttribute('action') || '').split('?')[0]);
  }

  // The hint inside every search box, in grey: "AI SHOPPER: what can I buy under 15 pounds / banana / strawberry"
  function applyPlaceholders() {
    var text = innerWidth < 520 ? copy.placeholderShort : copy.placeholder;
    [].forEach.call(document.querySelectorAll('input[name="q"]'), function (el) {
      if (!isSearchInput(el)) return;
      el.setAttribute('placeholder', text); el.setAttribute('aria-label', text); el.classList.add('jsai-ph');
    });
  }
  applyPlaceholders();
  window.addEventListener('resize', applyPlaceholders);
  document.addEventListener('focusin', function (e) { if (isSearchInput(e.target)) applyPlaceholders(); });

  var debounce;
  // No pre-loading on focus: shoppers who type a plain keyword never cost the catalogue download.
  document.addEventListener('input', function (e) {
    if (!isSearchInput(e.target)) return;
    var q = cleanText(e.target.value);
    clearTimeout(debounce);
    if (!q || !isConversational(q)) { hidePanel(); return; }
    debounce = setTimeout(function () { run(q, e.target); }, 300);
  }, true);
  document.addEventListener('submit', function (e) {
    var input = e.target && e.target.querySelector && e.target.querySelector('input[name="q"]');
    if (!isSearchInput(input)) return;
    var q = cleanText(input.value);
    if (q && isConversational(q)) { e.preventDefault(); clearTimeout(debounce); run(q, input); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hidePanel(); });
  document.addEventListener('click', function (e) {
    if (!state.panel || state.panel.hasAttribute('hidden')) return;
    if (state.panel.contains(e.target) || isSearchInput(e.target)) return;
    hidePanel();
  });
  window.addEventListener('resize', placePanel);
  window.addEventListener('scroll', function () { if (state.panel && !state.panel.hasAttribute('hidden')) placePanel(); }, { passive: true });

  // keyword searches that reach the results page: log them (zero-result gaps) without any AI
  if (cfg.search && cfg.search.terms && cfg.apiBase) {
    var terms = cleanText(cfg.search.terms);
    if (terms && !state.logged[terms]) {
      state.logged[terms] = true;
      var n = Number(cfg.search.count) || 0;
      var body = JSON.stringify({ q: terms, conv: isConversational(terms), shown: n, ai: 'none' });
      try { if (navigator.sendBeacon) navigator.sendBeacon(cfg.apiBase + '/api/log', new Blob([body], { type: 'text/plain' })); } catch (e2) { /* ignore */ }
    }
  }

  X.page = { resolve: resolve, productRow: productRow, addToCart: addToCart, section: section };
})(window);